import { eventEmitter } from '../../decorators'
import { EventEmitterInterface } from '../../utils/EventEmitter'
import Service /* , { ServiceConfig } */ from '../Service'
import Document from './Document'
import Query from './Query'
// export interface ClientConfig extends ServiceConfig {}

@eventEmitter
export default class PG extends Service implements EventEmitterInterface {
  // constructor(config: ServiceConfig) {
  //   super(config)
  // }

  // EventEmitter interface implementation
  on(event: string, listener: (...args: any[]) => void): void {
    return
  }
  removeListener(event: string, listener: (...args: any[]) => void): void {
    return
  }
  emit(event: string, ...args: any[]): void {
    return
  }
  once(event: string, listener: (...args: any[]) => void): void {
    return
  }

  // api
  document(
    dbId: string,
    schema: string,
    collection: string,
    id?: string
  ): Document {
    return new Document(this.app, dbId, schema, collection, id)
  }

  query(dbId: string, schema: string, collection: string): Query {
    return new Query(this.app, dbId, schema, collection)
  }
}
